export const GET_RESOURCES_REQUEST = "GET_RESOURCES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_RESOURCE = 'INSERT_RESOURCE'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'